<template>
  <transition name="fade">
    <div class="main" v-if="show">
      <div>
        <v-breadcrumbs :items="items" large></v-breadcrumbs>
      </div>
      <v-container>
        <v-row>
          <!-- Change sm to four for three card -->
          <v-col>
            <v-card class="mx-auto my-1 make-transparant" elevation="5" outlined shaped>
              <v-parallax height="180" :src="require('@/assets/codingwallpaper.jpg')">
                <v-row class="text-center">
                  <v-col class="mt-12">
                    <h2 class="display-2 font-weight-bold mb-1">
                      Powershell - Deduplicate
                    </h2>
                    <hr />
                    <!-- <p class="subheading font-weight-regular">
                      Some working code examples in diffrent programming languages like
                      Powershell, Bash, Python, PHP, Javascripts and others.
                    </p> -->
                  </v-col>
                </v-row>
              </v-parallax>
              <v-card-text>
                <v-row justify="center">
                  <p class="mt-2 display-1 font-weight-bold">
                  Under-construction
                  </p>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="mb-5" cols="12">
            <v-row justify="center">
              <!-- <p class="display-1 font-weight-bold">
              Working on adding this content
              </p> -->
              <v-btn
                v-for="(next, i) in projects"
                :key="i"
                elevation="5"
                rounded
                x-large
                router-link
                :to="next.href"
                class="mr-4 mb-2"
                :disabled="next.disabled"
              >
                <v-icon size="48px" color="primary" class="mr-4">
                  {{ next.icon }}
                </v-icon>
                {{ next.text }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </transition>
</template>

<script>
// @ is an alias to /src
// import Services from "../components/Services";
// import About from "../components/About";
// import Employees from "../components/Employees";
// import Contact from "../components/Contact";
// import Projects from "../components/Projects";
// import CodeExamples from "../components/CodeExamples";
// import LogoSlogan from '../components/LogoSlogan';

export default {
  name: "Home",
  components: {
    // Services,
    // About,
    // Employees,
    // Projects,
    // CodeExamples,
    // Contact,
    // LogoSlogan,
  },
  created: function () {
    // `this` points to the vm instance
    setTimeout(() => {
      this.show = true;
    }, 1000);
  },
  data: () => ({
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Code & Project Examples",
        disabled: false,
        href: "#/coding",
      },
      {
        text: "Powershell",
        disabled: false,
        href: "#/coding/powershell",
      },
      {
        text: "Deduplicate",
        disabled: true,
        href: "Deduplicate",
      },
    ],
    projects: [
      // {
      //   text: "Deduplicate",
      //   icon: "",
      //   href: "/powershell/Deduplicate",
      //   disabled: true,
      // },
    ],
    show: false,
  }),
};
</script>
